import { type FC } from 'react';

import {
	createSingleQueryParamHook,
	useRouteActions,
} from '@confluence/route-manager/entry-points/RouteState.ts';

const useFocusedTaskIdQueryParam = createSingleQueryParamHook('focusedTaskId');

export const TaskScrollComponent: FC = () => {
	const focusedTaskId = useFocusedTaskIdQueryParam();
	const { setQueryParams } = useRouteActions();

	if (focusedTaskId) {
		// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
		const taskElement = document.querySelector(`[data-task-local-id="${focusedTaskId}"]`);
		if (taskElement) {
			taskElement.scrollIntoView({
				behavior: 'instant',
				inline: 'center',
				block: 'center',
			});
			// Remove the query param immediately after task scroll is complete
			setQueryParams({
				focusedTaskId: undefined,
			});
		}
	}

	return null;
};
